import { setEquipmentDetailsData, resetEquipmentDetailsData } from '../../../redux/equipmentDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import EquipmentDetailsContent from './equipmentDetailsContent';
import EquipmentDetailsHeader from './equipmentDetailsHeader';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const EquipmentDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchEquipmentDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`equipment/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setEquipmentDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations équipement :', error);
            CustomErrorLogger(error, 'Erreur dans fetchEquipmentDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch equipment details on mount and cleanup on unmount
    useEffect(() => {
        fetchEquipmentDetails();
        return () => {
            dispatch(resetEquipmentDetailsData());
        };
    }, [dispatch, fetchEquipmentDetails]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <EquipmentDetailsHeader />
                    <EquipmentDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default EquipmentDetails;